import { Tooltip } from "@mui/material";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import React from "react";

const RequestDelivery = (props) => {
  return (
    <>
      <div className="flex">
        <Tooltip title="Request Delivery">
          <button
            type="button"
            aria-label="Request Delivery"
            className="app-icon-btn text-sky-600 hover:text-sky-700 dark:text-sky-300 dark:hover:text-sky-200"
            onClick={() => {
              props.setOrderID(props.rowData.OrderID);
              props.setCustomer(props.rowData.Customer);
              props.setJob(props.rowData.Job);
              props.setSO(props.rowData["SO #"]);
              props.setSelectedRowData(props.rowData);
              props.setIsOpen(true);
            }}
          >
            <LocalShippingIcon fontSize="small" />
          </button>
        </Tooltip>
      </div>
    </>
  );
};

export default RequestDelivery;
